import React from "react";
import {observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const DeleteNodeDialog = observer(() => {
    const {modalStore, generalStore} = useStores();

    function downHandler({key}) {
        if (key === 'Enter') {
            modalStore.modalData.deleteMethod();
            closeModal();
        }
    }

    function closeModal() {
        window.removeEventListener('keydown', downHandler)
        modalStore.isDeleteNodeDialogOpen = false;
        modalStore.modalData = {};
    }

    return (
        <GeneralDialog
            openControl='isDeleteNodeDialogOpen'
            className='delete-dialog'
            onEnter={() => window.addEventListener('keydown', downHandler)}
            title={generalStore.translate('deleteNode')}
            body={
                <div className="dialog-description">
                    {modalStore?.modalData?.isMultiple ?
                        generalStore.translate('areYouSureYouWantToDeleteTheseNodes') :
                        (modalStore?.modalData?.isConnection ?
                                generalStore.translate('areYouSureYouWantToDeleteThisConnection') :
                                generalStore.translate('areYouSureYouWantToDeleteThisNode')
                        )
                    }?
                </div>
            }
            onConfirm={() => {
                modalStore.modalData.deleteMethod();
                closeModal();
            }}
            confirmText={generalStore.translate('delete')}
        />
    );
});

export default DeleteNodeDialog;
